import { render, staticRenderFns } from "./AtendimentoByContratoList.vue?vue&type=template&id=b72d47e6&scoped=true"
import script from "./AtendimentoByContratoList.vue?vue&type=script&lang=js"
export * from "./AtendimentoByContratoList.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoByContratoList.vue?vue&type=style&index=0&id=b72d47e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72d47e6",
  null
  
)

export default component.exports